// Social platforms a tenant can link from their site footer. The slug is what
// site_config.social_links_json stores; the label is what portals display.
// The template keeps its own icon set keyed by these slugs (apps/template is
// dependency-free) and silently skips slugs it doesn't recognise, so adding a
// platform here is safe for already-built sites.
export const SOCIAL_PLATFORMS = [
  { slug: "instagram", label: "Instagram" },
  { slug: "facebook", label: "Facebook" },
  { slug: "tiktok", label: "TikTok" },
  { slug: "x", label: "X (Twitter)" },
  { slug: "youtube", label: "YouTube" },
  { slug: "linkedin", label: "LinkedIn" },
] as const;

export type SocialPlatform = (typeof SOCIAL_PLATFORMS)[number]["slug"];

export interface SocialLink {
  platform: SocialPlatform;
  url: string;
}

export const MAX_SOCIAL_LINKS = SOCIAL_PLATFORMS.length;

export function isSocialPlatform(value: unknown): value is SocialPlatform {
  return SOCIAL_PLATFORMS.some((platform) => platform.slug === value);
}
